export default __webpack_public_path__ + "static/media/hackerDeck.5b60c9fa.png";